/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Access_PendingInputs */

const en_access_pending = /** @type {(inputs: Access_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access Pending`)
};

const es_access_pending = /** @type {(inputs: Access_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso Pendiente`)
};

const fr_access_pending = /** @type {(inputs: Access_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès en attente`)
};

const de_access_pending = /** @type {(inputs: Access_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugang ausstehend`)
};

const id_access_pending = /** @type {(inputs: Access_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses Tertunda`)
};

/** @type {(inputs: Access_PendingInputs) => LocalizedString} */
const ja_access_pending = en_access_pending;

/** @type {(inputs: Access_PendingInputs) => LocalizedString} */
const zh_access_pending = en_access_pending;

/** @type {(inputs: Access_PendingInputs) => LocalizedString} */
const ar_access_pending = en_access_pending;

/** @type {(inputs: Access_PendingInputs) => LocalizedString} */
const it_access_pending = en_access_pending;

/** @type {(inputs: Access_PendingInputs) => LocalizedString} */
const ru_access_pending = en_access_pending;

/** @type {(inputs: Access_PendingInputs) => LocalizedString} */
const pt_access_pending = en_access_pending;

/** @type {(inputs: Access_PendingInputs) => LocalizedString} */
const ko_access_pending = en_access_pending;

/**
* | output |
* | --- |
* | "Access Pending" |
*
* @param {Access_PendingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const access_pending = /** @type {((inputs?: Access_PendingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Access_PendingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_access_pending(inputs)
	if (locale === "es") return es_access_pending(inputs)
	if (locale === "fr") return fr_access_pending(inputs)
	if (locale === "de") return de_access_pending(inputs)
	if (locale === "ja") return ja_access_pending(inputs)
	if (locale === "zh") return zh_access_pending(inputs)
	if (locale === "ar") return ar_access_pending(inputs)
	if (locale === "id") return id_access_pending(inputs)
	if (locale === "it") return it_access_pending(inputs)
	if (locale === "ru") return ru_access_pending(inputs)
	if (locale === "pt") return pt_access_pending(inputs)
	return ko_access_pending(inputs)
});